export const ORDER_DIRECTIONS = ['asc', 'desc'] as const;

export type OrderDirection = 'asc' | 'desc';

export type FilterMode = 'display' | 'hide';

export const failsModeFilter = (
  selected: string[] | undefined,
  value: string,
  mode: FilterMode | undefined,
) => {
  if (!selected?.length) return false;
  const matches = selected.includes(value);
  return (mode ?? 'display') === 'display' ? !matches : matches;
};

export const toggleFilterValue = <T>(values: T[] | undefined, value: T) => {
  const next = values?.includes(value)
    ? values.filter((item) => item !== value)
    : [...(values ?? []), value];
  return next.length ? next : undefined;
};
